/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClickFinderDocumentList } from '../models/click-finder-document-list';
import { DocumentList } from '../models/document-list';
import { InProgressDocumentList } from '../models/in-progress-document-list';
import { InRecycleBinDocumentList } from '../models/in-recycle-bin-document-list';
import { MagnetList } from '../models/magnet-list';
import { RemoveVaultMemberList } from '../models/remove-vault-member-list';
import { SimpleSearchDocumentList } from '../models/simple-search-document-list';
import { TagSection } from '../models/tag-section';
import { UserGroupList } from '../models/user-group-list';
import { Vault } from '../models/vault';
import { vaultCreateVaultMagnet } from '../fn/vault/vault-create-vault-magnet';
import { VaultCreateVaultMagnet$Params } from '../fn/vault/vault-create-vault-magnet';
import { vaultCreateVaultSearchQuery } from '../fn/vault/vault-create-vault-search-query';
import { VaultCreateVaultSearchQuery$Params } from '../fn/vault/vault-create-vault-search-query';
import { vaultGetClickFinderDocumentList } from '../fn/vault/vault-get-click-finder-document-list';
import { VaultGetClickFinderDocumentList$Params } from '../fn/vault/vault-get-click-finder-document-list';
import { vaultGetDocumentList } from '../fn/vault/vault-get-document-list';
import { VaultGetDocumentList$Params } from '../fn/vault/vault-get-document-list';
import { vaultGetInProgressDocumentList } from '../fn/vault/vault-get-in-progress-document-list';
import { VaultGetInProgressDocumentList$Params } from '../fn/vault/vault-get-in-progress-document-list';
import { vaultGetInRecycleBinDocumentList } from '../fn/vault/vault-get-in-recycle-bin-document-list';
import { VaultGetInRecycleBinDocumentList$Params } from '../fn/vault/vault-get-in-recycle-bin-document-list';
import { vaultGetList } from '../fn/vault/vault-get-list';
import { VaultGetList$Params } from '../fn/vault/vault-get-list';
import { vaultGetMagnetList } from '../fn/vault/vault-get-magnet-list';
import { VaultGetMagnetList$Params } from '../fn/vault/vault-get-magnet-list';
import { vaultGetMemberList } from '../fn/vault/vault-get-member-list';
import { VaultGetMemberList$Params } from '../fn/vault/vault-get-member-list';
import { vaultGetRemoveMemberList } from '../fn/vault/vault-get-remove-member-list';
import { VaultGetRemoveMemberList$Params } from '../fn/vault/vault-get-remove-member-list';
import { vaultGetSimpleSearchDocumentList } from '../fn/vault/vault-get-simple-search-document-list';
import { VaultGetSimpleSearchDocumentList$Params } from '../fn/vault/vault-get-simple-search-document-list';
import { vaultGetTags } from '../fn/vault/vault-get-tags';
import { VaultGetTags$Params } from '../fn/vault/vault-get-tags';
import { vaultGetUserGroupList } from '../fn/vault/vault-get-user-group-list';
import { VaultGetUserGroupList$Params } from '../fn/vault/vault-get-user-group-list';
import { vaultGetVault } from '../fn/vault/vault-get-vault';
import { VaultGetVault$Params } from '../fn/vault/vault-get-vault';
import { VaultList } from '../models/vault-list';
import { VaultMemberList } from '../models/vault-member-list';

@Injectable({ providedIn: 'root' })
export class VaultService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vaultGetClickFinderDocumentList()` */
  static readonly VaultGetClickFinderDocumentListPath = '/vault/{vaultId}/click-finder/document/list';

  /**
   * Get click finder document list.
   *
   * Get click finder document list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetClickFinderDocumentList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultGetClickFinderDocumentList$Response(params: VaultGetClickFinderDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickFinderDocumentList>> {
    const obs = vaultGetClickFinderDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get click finder document list.
   *
   * Get click finder document list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetClickFinderDocumentList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultGetClickFinderDocumentList(params: VaultGetClickFinderDocumentList$Params, context?: HttpContext): Observable<ClickFinderDocumentList> {
    const resp = this.vaultGetClickFinderDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ClickFinderDocumentList>): ClickFinderDocumentList => r.body)
    );
  }

  /** Path part for operation `vaultCreateVaultMagnet()` */
  static readonly VaultCreateVaultMagnetPath = '/vault/{vaultId}/magnet';

  /**
   * Create magnet.
   *
   * Create magnet
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultCreateVaultMagnet()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultCreateVaultMagnet$Response(params: VaultCreateVaultMagnet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = vaultCreateVaultMagnet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create magnet.
   *
   * Create magnet
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultCreateVaultMagnet$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultCreateVaultMagnet(params: VaultCreateVaultMagnet$Params, context?: HttpContext): Observable<void> {
    const resp = this.vaultCreateVaultMagnet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vaultCreateVaultSearchQuery()` */
  static readonly VaultCreateVaultSearchQueryPath = '/vault/{vaultId}/search-query';

  /**
   * Create search query.
   *
   * Create search query
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultCreateVaultSearchQuery()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultCreateVaultSearchQuery$Response(params: VaultCreateVaultSearchQuery$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = vaultCreateVaultSearchQuery(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create search query.
   *
   * Create search query
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultCreateVaultSearchQuery$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  vaultCreateVaultSearchQuery(params: VaultCreateVaultSearchQuery$Params, context?: HttpContext): Observable<void> {
    const resp = this.vaultCreateVaultSearchQuery$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vaultGetVault()` */
  static readonly VaultGetVaultPath = '/vault/{vaultId}';

  /**
   * Get vault by ID.
   *
   * Get vault by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetVault()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetVault$Response(params: VaultGetVault$Params, context?: HttpContext): Observable<StrictHttpResponse<Vault>> {
    const obs = vaultGetVault(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get vault by ID.
   *
   * Get vault by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetVault$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetVault(params: VaultGetVault$Params, context?: HttpContext): Observable<Vault> {
    const resp = this.vaultGetVault$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Vault>): Vault => r.body)
    );
  }

  /** Path part for operation `vaultGetDocumentList()` */
  static readonly VaultGetDocumentListPath = '/vault/{vaultId}/document/list';

  /**
   * Search top level documents of the vault.
   *
   * Search top level documents of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetDocumentList$Response(params: VaultGetDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentList>> {
    const obs = vaultGetDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search top level documents of the vault.
   *
   * Search top level documents of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetDocumentList(params: VaultGetDocumentList$Params, context?: HttpContext): Observable<DocumentList> {
    const resp = this.vaultGetDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentList>): DocumentList => r.body)
    );
  }

  /** Path part for operation `vaultGetInProgressDocumentList()` */
  static readonly VaultGetInProgressDocumentListPath = '/vault/{vaultId}/in-progress-document/list';

  /**
   * Get in progress documents of the vault.
   *
   * Get in progress documents of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetInProgressDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetInProgressDocumentList$Response(params: VaultGetInProgressDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<InProgressDocumentList>> {
    const obs = vaultGetInProgressDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get in progress documents of the vault.
   *
   * Get in progress documents of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetInProgressDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetInProgressDocumentList(params: VaultGetInProgressDocumentList$Params, context?: HttpContext): Observable<InProgressDocumentList> {
    const resp = this.vaultGetInProgressDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InProgressDocumentList>): InProgressDocumentList => r.body)
    );
  }

  /** Path part for operation `vaultGetInRecycleBinDocumentList()` */
  static readonly VaultGetInRecycleBinDocumentListPath = '/vault/{vaultId}/in-recycle-bin-document/list';

  /**
   * Search in recycle bin documents of the vault.
   *
   * Search in recycle bin documents of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetInRecycleBinDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetInRecycleBinDocumentList$Response(params: VaultGetInRecycleBinDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<InRecycleBinDocumentList>> {
    const obs = vaultGetInRecycleBinDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search in recycle bin documents of the vault.
   *
   * Search in recycle bin documents of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetInRecycleBinDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetInRecycleBinDocumentList(params: VaultGetInRecycleBinDocumentList$Params, context?: HttpContext): Observable<InRecycleBinDocumentList> {
    const resp = this.vaultGetInRecycleBinDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InRecycleBinDocumentList>): InRecycleBinDocumentList => r.body)
    );
  }

  /** Path part for operation `vaultGetMagnetList()` */
  static readonly VaultGetMagnetListPath = '/vault/{vaultId}/magnet/list';

  /**
   * Get top level magnets of the vault.
   *
   * Get top level magnets of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetMagnetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetMagnetList$Response(params: VaultGetMagnetList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetList>> {
    const obs = vaultGetMagnetList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get top level magnets of the vault.
   *
   * Get top level magnets of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetMagnetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetMagnetList(params: VaultGetMagnetList$Params, context?: HttpContext): Observable<MagnetList> {
    const resp = this.vaultGetMagnetList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MagnetList>): MagnetList => r.body)
    );
  }

  /** Path part for operation `vaultGetMemberList()` */
  static readonly VaultGetMemberListPath = '/vault/{vaultId}/member/list';

  /**
   * Get members of the vault.
   *
   * Get members of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetMemberList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetMemberList$Response(params: VaultGetMemberList$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultMemberList>> {
    const obs = vaultGetMemberList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get members of the vault.
   *
   * Get members of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetMemberList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetMemberList(params: VaultGetMemberList$Params, context?: HttpContext): Observable<VaultMemberList> {
    const resp = this.vaultGetMemberList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VaultMemberList>): VaultMemberList => r.body)
    );
  }

  /** Path part for operation `vaultGetRemoveMemberList()` */
  static readonly VaultGetRemoveMemberListPath = '/vault/{vaultId}/remove-member/list';

  /**
   * Get remove members of the vault.
   *
   * Get remove members of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetRemoveMemberList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetRemoveMemberList$Response(params: VaultGetRemoveMemberList$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveVaultMemberList>> {
    const obs = vaultGetRemoveMemberList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get remove members of the vault.
   *
   * Get remove members of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetRemoveMemberList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetRemoveMemberList(params: VaultGetRemoveMemberList$Params, context?: HttpContext): Observable<RemoveVaultMemberList> {
    const resp = this.vaultGetRemoveMemberList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RemoveVaultMemberList>): RemoveVaultMemberList => r.body)
    );
  }

  /** Path part for operation `vaultGetSimpleSearchDocumentList()` */
  static readonly VaultGetSimpleSearchDocumentListPath = '/vault/{vaultId}/simple-search/document/list';

  /**
   * Search documents by text.
   *
   * Get click finder document list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetSimpleSearchDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetSimpleSearchDocumentList$Response(params: VaultGetSimpleSearchDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleSearchDocumentList>> {
    const obs = vaultGetSimpleSearchDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search documents by text.
   *
   * Get click finder document list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetSimpleSearchDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetSimpleSearchDocumentList(params: VaultGetSimpleSearchDocumentList$Params, context?: HttpContext): Observable<SimpleSearchDocumentList> {
    const resp = this.vaultGetSimpleSearchDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SimpleSearchDocumentList>): SimpleSearchDocumentList => r.body)
    );
  }

  /** Path part for operation `vaultGetTags()` */
  static readonly VaultGetTagsPath = '/vault/{vaultId}/tag/list';

  /**
   * Get all tags of the vault.
   *
   * Get all tags of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetTags$Response(params: VaultGetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
    const obs = vaultGetTags(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all tags of the vault.
   *
   * Get all tags of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetTags(params: VaultGetTags$Params, context?: HttpContext): Observable<Array<TagSection>> {
    const resp = this.vaultGetTags$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TagSection>>): Array<TagSection> => r.body)
    );
  }

  /** Path part for operation `vaultGetUserGroupList()` */
  static readonly VaultGetUserGroupListPath = '/vault/{vaultId}/user-group/list';

  /**
   * Get user groups of the vault.
   *
   * Get user groups of the vault
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetUserGroupList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetUserGroupList$Response(params: VaultGetUserGroupList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGroupList>> {
    const obs = vaultGetUserGroupList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user groups of the vault.
   *
   * Get user groups of the vault
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetUserGroupList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetUserGroupList(params: VaultGetUserGroupList$Params, context?: HttpContext): Observable<UserGroupList> {
    const resp = this.vaultGetUserGroupList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserGroupList>): UserGroupList => r.body)
    );
  }

  /** Path part for operation `vaultGetList()` */
  static readonly VaultGetListPath = '/vault/list';

  /**
   * Get all user related vaults.
   *
   * Get all vaults for the current user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vaultGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetList$Response(params?: VaultGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultList>> {
    const obs = vaultGetList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all user related vaults.
   *
   * Get all vaults for the current user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vaultGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vaultGetList(params?: VaultGetList$Params, context?: HttpContext): Observable<VaultList> {
    const resp = this.vaultGetList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VaultList>): VaultList => r.body)
    );
  }

}
